var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9,
    height: 19,
    viewBox: "0 0 9 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kla2ktcgla",
    d: "M0 0.143L9 0.143 9 18.143 0 18.143z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "kt3onvfyjb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kla2ktcgla"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.283 13.937v-4.08l-.001-.06c-.005-.045-.026-.07-.077-.069-.07.002-.14 0-.21 0H.069c-.045-.004-.07-.025-.069-.07V6.805c0-.164.003-.167.17-.167h1.994c.103-.001.119-.015.119-.115v-1.09c-.001-.15-.008-.3-.007-.449.001-.378-.002-.756.01-1.134.007-.187.04-.374.07-.56.043-.27.12-.531.226-.782.161-.376.373-.724.652-1.031C3.712.95 4.309.609 4.99.396c.284-.09.575-.15.87-.186.171-.021.345-.025.517-.036.165-.011.33-.032.495-.031.308.001.617 0 .922.028.212.02.424.028.635.047l.42.034c.032.002.067.002.094.015.02.01.044.039.044.06-.002.274-.006.548-.012.822-.005.208-.016.415-.021.623-.006.231-.007.463-.013.695-.005.188-.014.375-.022.562-.001.03-.002.06-.014.086-.008.015-.038.027-.059.028-.092.004-.185.006-.278.006-.34 0-.681.001-1.022 0-.256 0-.511-.008-.767-.005-.177.002-.352.019-.523.076-.317.106-.501.32-.575.634-.042.177-.054.356-.054.535-.003.703-.001 1.406-.001 2.11v.05c.003.072.021.09.097.09h3.204c.052-.002.075.017.073.072-.01.238-.015.477-.024.716-.006.165-.015.33-.023.495l-.035.72c-.01.205-.02.41-.033.615-.009.142-.021.284-.035.426-.002.016-.025.034-.042.042-.018.008-.04.004-.062.004h-3.01c-.096 0-.108.011-.11.104v8.22c-.001.075-.016.09-.094.09H2.368c-.067 0-.082-.016-.085-.082v-.06-4.064",
    mask: "url(#kt3onvfyjb)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.02a8ef0c.svg";
export { ForwardRef as ReactComponent };